// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function issue_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var issue_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "issue_name"), null));
  if (issue_name.TAG === /* Ok */0) {
    var issue_comment_required = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "issue_comment_required"), null));
    if (issue_comment_required.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                issue_name: issue_name._0,
                issue_comment_required: issue_comment_required._0
              }
            };
    }
    var e = issue_comment_required._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".issue_comment_required" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = issue_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".issue_name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var issues = Decco.listFromJson(issue_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "issues"), null));
  if (issues.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              issues: issues._0
            }
          };
  }
  var e = issues._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".issues" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  issue_decode ,
  t_decode ,
  
}
/* No side effect */
